import { render, staticRenderFns } from "./HumanMap.vue?vue&type=template&id=f99a0dbe&scoped=true&"
import script from "./HumanMap.vue?vue&type=script&lang=js&"
export * from "./HumanMap.vue?vue&type=script&lang=js&"
import style0 from "./HumanMap.vue?vue&type=style&index=0&id=f99a0dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99a0dbe",
  null
  
)

export default component.exports